import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useFieldInitialData } from "../../../contexts/field-initial-data-context.js";
import { useFieldAttributes } from "../../../services/field-attributes.js";
import { AppointmentFieldWUT } from "../../../ui/appointment-field/appointment.js";
import { FieldDescriptionWUT } from "../../../ui/field-description/field-description-wut.js";
import { FieldErrorWUT } from "../../../ui/field-error/field-error-wut.js";
import { FieldLabelWUT } from "../../../ui/field-label/field-label-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const AppointmentWUT = (props) => {
  const {
    id,
    description,
    error,
    hasError = false,
    errorMessage,
    required,
    label,
    hideLabel,
    FieldLayout,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    target
  } = props;
  const { labelId, inputId, descriptionId, ariaDescribedBy, errorId } = useFieldAttributes(id, error, description);
  const initialData = useFieldInitialData(
    FIELD_TYPES.APPOINTMENT
  );
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => /* @__PURE__ */ jsx(
        AppointmentFieldWUT,
        {
          ...props,
          initialData,
          inputId,
          ariaLabelledBy: labelId,
          ariaDescribedBy,
          fieldId: id
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  AppointmentWUT
};
//# sourceMappingURL=appointment-wut.js.map
